import React, { useState } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { orderBy } from 'lodash';
import { getSvgData, formatNumber, getObjectStatus } from '../helpers/helpers';
import { useModal } from '../contexts/ModalContext';
import BackLink from './BackLink';

import './ObjectTable.scss';

export function ObjectTableItem(props) {
  const { item, activeObjectId, handleActiceObject } = props;

  let classes = 'ObjectTableItem';

  if (item.id === activeObjectId) {
    classes += ' active';
  }

  const status = getObjectStatus(item.status);

  return (
    <tr
      className={classes}
      data-testid="object-table-item"
      onMouseEnter={() => {
        if (typeof handleActiceObject === 'function') {
          handleActiceObject(item.id);
        }
      }}
      onMouseLeave={() => {
        if (typeof handleActiceObject === 'function') {
          handleActiceObject(null);
        }
      }}
    >
      <td>
        <Link to={`/objekt/${item.id}`}>{item.number}</Link>
      </td>
      <td>
        <Link to={`/objekt/${item.id}`}>{status}</Link>
      </td>
      <td>
        <Link to={`/objekt/${item.id}`}>{item.rooms} rum</Link>
      </td>
      <td>
        <Link to={`/objekt/${item.id}`}>
          {item.price ? `${formatNumber(item.price)} SEK` : '-'}
        </Link>
      </td>
      <td>
        <Link to={`/objekt/${item.id}`}>
          {item.monthlyFee ? `${formatNumber(item.monthlyFee)} SEK` : '-'}
        </Link>
      </td>
      <td>
        <Link to={`/objekt/${item.id}`}>{item.size} m²</Link>
      </td>
      <td>
        <Link to={`/objekt/${item.id}`}>{item.floor}</Link>
      </td>
      <td className="building-cell">
        <Link to={`/objekt/${item.id}`}>Hus {item.number.charAt(0) || ''}</Link>
      </td>
    </tr>
  );
}

function SortButton(props) {
  return (
    <button
      onClick={props.sortCallback}
      data-sortkey={props.sortKey}
      data-testid="sort-button"
    >
      {props.label}
      <svg className="icon icon-chevrons-expand-vertical">
        <use xlinkHref="#icon-chevrons-expand-vertical"></use>
      </svg>
    </button>
  );
}

export default function ObjectTable({
  items = [],
  activeObjectId = null,
  handleActiceObject = null,
  building = null,
  sceneIndex = null,
  totalItems = 0,
  statusState,
}) {
  const svgData =
    sceneIndex && building ? getSvgData(sceneIndex, building) : null;

  const { setIsOpen } = useModal();
  const matchPrislista = useRouteMatch('/prislista/');

  const objects =
    svgData && typeof svgData.children !== 'undefined'
      ? svgData.children
          .filter((item) => {
            return item.attributes.id || false;
          })
          .map((item) => {
            return [...items].find((o) => {
              if (!o) {
                return false;
              }

              return o.number === item.attributes['data-name'];
            });
          })
      : items;

  const [sort, setSort] = useState('apartmentNumber');
  const [order, setOrder] = useState('desc');

  if (!objects) {
    return null;
  }

  const { showStatus, setShowStatus } = statusState;

  // The items inside object price list
  const sortedItems = orderBy([...objects], [sort], [order]);
  const rows = [...sortedItems].map((item) => {
    if (item) {
      return (
        <ObjectTableItem
          key={item.id}
          item={item}
          activeObjectId={activeObjectId}
          handleActiceObject={handleActiceObject}
        />
      );
    } else {
      return null;
    }
  });

  const handleSort = (event) => {
    const { currentTarget } = event;
    setOrder(order === 'desc' ? 'asc' : 'desc');
    setSort(currentTarget.getAttribute('data-sortkey'));
  };

  return (
    <>
      {rows.length === totalItems && <BackLink />}
      <div className="table-wrapper">
        <header className="table-header">
          <h2>
            {matchPrislista ? (
              <strong>Alla objekt</strong>
            ) : (
              <>
                I denna vy visas{' '}
                <strong>
                  {rows.length} av {totalItems}
                </strong>{' '}
                objekt i Hus {building}
              </>
            )}
          </h2>
          {!matchPrislista && (
            <p className="before-objects-table-helper">
              <button
                onClick={() => {
                  setIsOpen(true);
                }}
              >
                Byt vy
              </button>
              <button
                onClick={() => {
                  setShowStatus(!showStatus);
                }}
                className="toggle-status-button"
              >
                {showStatus ? 'Göm status' : 'Visa status'}
              </button>
            </p>
          )}
        </header>
        <div className="table-container">
          <table className="ObjectTable" data-testid="object-table">
            <thead className="ObjectsTableHead">
              <tr>
                <th>
                  <SortButton
                    sortCallback={handleSort}
                    sortKey="number"
                    label="LghNr"
                  />
                </th>
                <th>
                  <SortButton
                    sortCallback={handleSort}
                    sortKey="status"
                    label="Status"
                  />
                </th>
                <th>
                  <SortButton
                    sortCallback={handleSort}
                    sortKey="rooms"
                    label="Antal rum"
                  />
                </th>
                <th>
                  <SortButton
                    sortCallback={handleSort}
                    sortKey="price"
                    label="Pris"
                  />
                </th>
                <th>
                  <SortButton
                    sortCallback={handleSort}
                    sortKey="monthlyFee"
                    label="Avgift"
                  />
                </th>
                <th>
                  <SortButton
                    sortCallback={handleSort}
                    sortKey="size"
                    label="Storlek"
                  />
                </th>
                <th>
                  <SortButton
                    sortCallback={handleSort}
                    sortKey="floor"
                    label="Våning"
                  />
                </th>
                <th>
                  <strong>Hus</strong>
                </th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </table>
        </div>
      </div>
    </>
  );
}
